import { gql } from "@apollo/client";

export const SUBMIT_BULK_EDIT = gql`
  mutation submitBulkEdit($templateId: ID!, $bulkEditIds: [String]!) {
    submitBulkEdit(templateId: $templateId, bulkEditIds: $bulkEditIds) {
      ok
    }
  }
`;
